import { useContext, useState } from 'react';
import PublicEventFormContext from '../../StateManagment/PublicEventFormContext';
import { useFirestoreGeneralOrderBy } from '../../firebase/useFirestore.js';

const MultipleOptionsField = ({ field, type, onChange }) => {
  // Op het openbare formulier uit getPublicEventForm; elders (AddEvent) uit
  // Firestore. '' slaat de hook over.
  const publicForm = useContext(PublicEventFormContext);
  const optionsRead = useFirestoreGeneralOrderBy(
    'MultipleQuestionOptions',
    'Field',
    publicForm ? '' : field.ID || '',
    'Position',
    'asc'
  );
  const options = publicForm ? (publicForm.options[field.ID] || []) : optionsRead;

  // Local selection state: [{ optionId, value }]
  const [selected, setSelected] = useState([]);

  // ---- Radio (one) ----
  const handleRadio = (option) => {
    setSelected([{ optionId: option.ID, value: option.Option }]);
    onChange({
      fieldId: field.ID,
      type: 'multiple-one',
      replace: { optionId: option.ID, value: option.Option },
    });
  };

  const handleRadioOtherText = (e, option) => {
    const val = e.target.value;
    setSelected([{ optionId: option.ID, value: val }]);
    onChange({
      fieldId: field.ID,
      type: 'multiple-one',
      replace: { optionId: option.ID, value: val },
    });
  };

  // ---- Checkbox (multiple) ----
  const handleCheckbox = (option, checked) => {
    if (checked) {
      const item = { optionId: option.ID, value: option.Option };
      setSelected((prev) => [...prev, item]);
      onChange({
        fieldId: field.ID,
        type: 'multiple-multiple',
        add: [item],
        remove: [],
      });
    } else {
      setSelected((prev) => prev.filter((x) => x.optionId !== option.ID));
      onChange({
        fieldId: field.ID,
        type: 'multiple-multiple',
        add: [],
        remove: [{ optionId: option.ID }],
      });
    }
  };

  const handleCheckboxOtherText = (e, option) => {
    const val = e.target.value;
    setSelected((prev) => {
      const exists = prev.find((x) => x.optionId === option.ID);
      if (exists) {
        return prev.map((x) => (x.optionId === option.ID ? { ...x, value: val } : x));
      }
      return [...prev, { optionId: option.ID, value: val }];
    });
    onChange({
      fieldId: field.ID,
      type: 'multiple-multiple',
      add: [{ optionId: option.ID, value: val }],
      remove: [],
    });
  };

  if (!options) return null;

  if (type === 'one') {
    const chosen = selected[0]?.optionId;
    return (
      <div className='event-builder-type-item-container event-builder-type-item-multiple-container'>
        <div id='options-container'>
          {options.map((opt) => {
            const isOther = opt.Option === 'other';
            const checked = chosen === opt.ID;
            return (
              <div key={opt.ID} className='question-option-container'>
                <input
                  className='question-checkbox-input'
                  type='radio'
                  id={opt.ID}
                  name={`option-${field.ID}`}
                  checked={checked}
                  onChange={() => handleRadio(opt)}
                />
                <label htmlFor={opt.ID}>
                  {isOther ? 'Anders, namelijk:' : opt.Option}
                </label>
                {isOther && checked && (
                  <input
                    id='multiple-question-other-input'
                    type='text'
                    placeholder='Geef hier uw antwoord'
                    onChange={(e) => handleRadioOtherText(e, opt)}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  // multiple
  return (
    <div className='event-builder-type-item-container event-builder-type-item-multiple-container'>
      <div id='open-options-container'>
        {options.map((opt) => {
          const isOther = opt.Option === 'other';
          const isChecked = !!selected.find((x) => x.optionId === opt.ID);
          const otherVal = selected.find((x) => x.optionId === opt.ID)?.value || '';
          return (
            <div key={opt.ID} className='question-option-container'>
              <input
                className='question-checkbox-input'
                type='checkbox'
                id={opt.ID}
                checked={isChecked}
                onChange={(e) => handleCheckbox(opt, e.target.checked)}
              />
              <label htmlFor={opt.ID}>
                {isOther ? 'Anders, namelijk:' : opt.Option}
              </label>
              {isOther && isChecked && (
                <input
                  id='multiple-question-other-input'
                  type='text'
                  placeholder='Geef hier uw antwoord'
                  value={otherVal}
                  onChange={(e) => handleCheckboxOtherText(e, opt)}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MultipleOptionsField;
